<template>
  <div class="libraryListHome">
    <div class="libraryListHome-box">
      <div class="left">
        <div
          class="Item"
          v-for="(item, index) in showList"
          :key="index"
          @click="toDetails(item.id)"
        >
          <div class="Item-Img">
            <el-image :src="item.cover" fit="fill"></el-image>
          </div>
          <div class="item-name">{{ item.name }}</div>
          <div class="item-tiem">{{ item.year }}年{{ item.num }}期</div>
        </div>
        <div
          class="clearData"
          style="margin-top: 30px;color: #999999;font-size: 14px;text-align: center;"
          v-if="showList.length === 0"
        >
          暂无数据
        </div>
      </div>
      <div class="right">
        <div
          class="item"
          :class="{ itemAct: yearType === item }"
          v-for="(item, index) in yearData"
          :key="index"
          @click="tabBook(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <Nav type="library" />
  </div>
</template>

<script>
import Nav from "@/components/h5/base/nav.vue"; // 关于我们
import { getMagazineList } from "@/api/api.js";

export default {
  data() {
    return {
      list: [],
      showList: [],
      ObjList: {},
      yearData: [],
      yearType: ""
    };
  },
  components: {
    Nav
  },
  mounted() {
    this.getMagazineList();
  },
  methods: {
    getMagazineList() {
      getMagazineList().then(res => {
        if (res.code === 0) {
          this.list = res.data;
          this.setList();
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    tabBook(year) {
      this.yearType = year;
      this.showList = this.ObjList[year];
    },
    setList() {
      this.ObjList = {};
      this.yearData = [];
      this.showList = [];
      this.list.forEach(el => {
        if (!this.ObjList[el.year]) {
          this.yearData.push(el.year);
          const Obj = {
            [el.year]: []
          };
          Object.assign(this.ObjList, Obj);
          this.ObjList[el.year].push(el);
        } else {
          this.ObjList[el.year].push(el);
        }
      });
      this.yearType = this.yearData[0];
      this.showList = this.ObjList[this.yearType];
    },
    toDetails(id) {
      const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
      if (ListObj.isExpire == "1") {
        this.$message({
          message: "您还不是会员，无法阅读",
          type: "warning"
        });
        return;
      }
      this.$router.push({
        name: "H5JournalDetails",
        query: { id: id }
      });
    }
  }
};
</script>

<style lang="less">
.libraryListHome {
  width: 100vw;
  height: 100vh;
  .libraryListHome-box {
    // padding: 16px;
    display: flex;
    box-sizing: border-box;
    height: calc(100vh - 56px);
    overflow-y: auto;
    .left {
      padding: 4px;
      width: calc(100%);
      .Item {
        display: flex;
        flex-direction: column;
        align-items: center;
        float: left;
        width: 33%;
        margin-bottom: 20px;
        .Item-Img {
          overflow: hidden;
          width: 90px;
          height: 120px;
          background: #d8d8d8;
        }
        .item-name {
          margin: 4px 0;
          width: 100px;
          font-size: 14px;
          color: #141414;
        }
        .item-tiem {
          width: 100px;
          font-size: 14px;
          color: #141414;
        }
      }
    }
    .right {
      width: 70px;
      height: 100%;
      background: #f5f5f5;
      .item {
        width: 100%;
        height: 44px;
        padding: 0 10px;
        line-height: 44px;
        font-size: 14px;
        color: #343434;
        box-sizing: border-box;
      }
      .itemAct {
        background: #ffffff;
        color: #6c2c66;
      }
    }
  }
}
</style>
